export async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}

export async function asyncMap(array, callback) {
  const results = array.map(callback);
  return Promise.all(results);
}



// WEBPACK FOOTER //
// ./src/utils/array.js